import React, {useState, useContext } from 'react'
import { Box, Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import InfoText from './infoText';
import BottomSheetModel from './bottomSheetModal';
import { GlobalStateContext } from '../context/globalStateProvider';
import config from "../config.json";
import { toast } from 'react-toastify';
import moment from 'moment';

const Recall = ({recallConfig, bookingDetails, refresh}) => {
    const {viewAllActivities, viewRecall, setViewRecall } = useContext(GlobalStateContext)
    const theme = useTheme();
    const [loading, setLoading] = useState(false)
    const recallTime = recallConfig?.recallTime || 15

    const recallHandler = () => {
        setLoading(true);
        const data = { action: "VEHICLE_RECALL" };
        fetch(`${config.HOST_NAME}/user/valet/${bookingDetails.valetServiceOrderId}/recall`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(json => {
                if (json.responseCode === 'SUCCESS') {
                    setViewRecall(false);
                    refresh()
                }
                 else toast.info(json.message);
            })
            .catch((error) => {
                console.log(error)
                toast.error('Something went wrong');
            })
            .finally(() => {
                setLoading(false);
            });
    }
    return (
        <>
           {(!viewRecall && !viewAllActivities) && <Box sx={theme.customStyles.valetRecallContainer}>
                <InfoText text={`After requesting your vehicle's return, it may take up to ${recallTime} minutes to arrive.`} />
                <Button onClick={() => setViewRecall(prev => !prev)} sx={{ ...theme.customStyles.gradientButton, height: "40px", borderRadius: "4px", padding: "0", marginTop: "8px", color: "#FFFFFF" }}>
                    <Box sx={{ fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Recall your Car</Box>
                </Button>
            </Box> }
            <BottomSheetModel title="Confirm Recall" isOpen={viewRecall} onClose={() => setViewRecall(false)} style={{height:"50svh"}} >
                <Box sx={{marginTop: "24px"}}>
                    <Box sx={{ color: "#3D3D3D", fontSize: "14px", fontWeight: theme.typography.fontWeightMedium, marginBottom: "24px" }}>
                       Once you recall, this action cannot be undone. Your car will be delivered in approximately {recallTime} minutes, around <span style={{color:"#18CC69"}}>{moment().add(recallTime, "minutes").format("h:mm A")}</span>. Please be available at the valet booth to collect your car.
                    </Box>
                    {/* <InfoText text="A text message with an OTP will be sent to your mobile number. Please verify it with the operator." style={{padding:"8px"}}/> */}
                </Box>
                <Box sx={theme.customStyles.recallActionContainer}>
                    <Button variant='outlined' color='error' onClick={() => setViewRecall(prev => !prev)} sx={{ width:"100%", height: "40px", textTransform:"none", borderRadius: "4px", padding: "0", marginTop: "8px", color: "#F7685B", marginRight: "12px" }}>
                        <Box sx={{ fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Cancel</Box>
                    </Button>
                    <Button onClick={() => recallHandler()} sx={{ ...theme.customStyles.gradientButton, width:"100%", height: "40px", borderRadius: "4px", padding: "0", marginTop: "8px", color: "#FFFFFF", marginLeft: "12px" }}>
                        <Box sx={{ fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Confirm</Box>
                        {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                    </Button>
                </Box>
            </BottomSheetModel>
        </>
    )
}

export default Recall